import { render, staticRenderFns } from "./deleteLabelProduct.vue?vue&type=template&id=45d72ec2"
import script from "./deleteLabelProduct.vue?vue&type=script&lang=js"
export * from "./deleteLabelProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports